var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlertSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 1c6.075 0 11 4.925 11 11 0 6.076-4.925 11-11 11S1 18.076 1 12C1 5.925 5.925 1 12 1zm-1.01 15.535 6.871-6.873a1.555 1.555 0 0 0-2.198-2.198l-5.495 5.495a.393.393 0 0 1-.555 0l-2.03-2.029a1.554 1.554 0 1 0-2.198 2.198l3.407 3.407c.607.605 1.59.605 2.198 0z"
})));
export default SvgAlertSuccess;